export default __webpack_public_path__ + "static/media/dinner.5e12f363.df9f62b0.svg";